import { __rest } from 'tslib';
import { useEffect } from 'react';
import { usePannellumViewer } from '../../../components/pannellum-viewer/PannellumProvider.js';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import { useError } from '../../../../utils/ErrorProvider.js';
import { useLoader } from '../../../../utils/LoaderProvider.js';
import { useRefetch } from '../../../../utils/RefetchProvider.js';
import '../../../../utils/NotificationProvider.js';
import '../../../../utils/ContactProvider.js';
import '../../../../utils/PolicyProvider.js';
import '../../../../utils/AnalyticsProvider.js';
import '@analytics/storage-utils';
import '../../../../types/AccessDevice.js';
import '../../../../types/Analytics.js';
import '../../../../types/CASACommunity.js';
import '../../../../types/Community.js';
import '../../../../types/DxSettings.js';
import '../../../../types/MagicButton.js';
import { PitchWarningType } from '../../../../types/Pannellum.js';
import '../../../../types/Prospect.js';
import '../../../../types/ProspectIntelligence.js';
import '../../../../types/Space.js';
import '../../../../types/Tour.js';
import '../../../../utils/analyticsPlugin.js';
import '../../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../../utils/cookieUtils.js';
import '../../../../utils/termsConditionsAgreementsUtils.js';
import '../../../../services/base/baseDiscoverService.js';
import '../../../../services/base/baseV3Service.js';
import '../../../../services/sgtService.js';
import '../../../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../../../services/base/internalApiBaseService.js';
import '../../../../services/base/casaBaseService.js';
import '../../../../services/scanRequestsService.js';
import '../../../../services/db/insightsReportsDB.js';
import 'dot-object';
import '../../../../apis/analytics/useDownloadAnalyticsReports.js';
import { useUpdateSpaceNode } from '../../../../apis/space/useUpdateSpaceNode.js';
import '../../../../apis/upload/useSignedURL.js';
import produce from 'immer';

const HotspotDropBox = ({ setPitchWarning }) => {
    const { getConfig, details, setViewerContext } = usePannellumViewer();
    const [updateSpaceNode, updatedSpace, updateSpaceNodeInProgress, updateSpaceNodeError] = useUpdateSpaceNode();
    const { nodeId } = getConfig();
    const { getContainer, mouseEventToCoords } = usePannellumViewer();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    useEffect(() => {
        if (updatedSpace) {
            setViewerContext({ details: updatedSpace });
            setRefetch({ sceneId: nodeId });
        }
    }, [updatedSpace]);
    useEffect(() => {
        if (updateSpaceNodeError) {
            setError(updateSpaceNodeError === null || updateSpaceNodeError === void 0 ? void 0 : updateSpaceNodeError.message);
        }
    }, [updateSpaceNodeError]);
    useEffect(() => {
        setLoader(updateSpaceNodeInProgress, "updateSpaceNode");
        return () => setLoader(false, "updateSpaceNode");
    }, [updateSpaceNodeInProgress]);
    const dropOverCb = (event) => {
        event.preventDefault();
        if (event.dataTransfer) {
            event.dataTransfer.dropEffect = "move";
        }
    };
    const verifyPitchValue = (pitch) => {
        let updatedPitch = pitch;
        if (pitch > -25 && pitch < 25) {
            updatedPitch = 0;
        }
        else if (pitch < -25) {
            setPitchWarning(PitchWarningType.Low);
            updatedPitch = -35;
        }
        else if (pitch > 25) {
            setPitchWarning(PitchWarningType.High);
            updatedPitch = 35;
        }
        return updatedPitch;
    };
    const dropCb = (event) => {
        var _a;
        event.preventDefault();
        const coordinates = mouseEventToCoords(event);
        let pitch = coordinates[0];
        const yaw = coordinates[1];
        const hostspotData = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.getData("hotspot");
        const { relatedContext, infospot, hotspot: { _id: hotspotId }, } = JSON.parse(hostspotData);
        const node = relatedContext.node;
        if (node) {
            let updatedSpaceNode;
            if (!infospot) {
                //@ts-ignore
                pitch = verifyPitchValue(pitch);
                const hotspotIndex = node === null || node === void 0 ? void 0 : node.nodeLinks.findIndex((item) => item._id === hotspotId);
                updatedSpaceNode = produce(node, (draftState) => {
                    draftState.nodeLinks[hotspotIndex] = Object.assign(Object.assign({}, draftState.nodeLinks[hotspotIndex]), { rotation: {
                            pitch,
                            yaw,
                        } });
                });
            }
            else {
                const infospotIndex = node.infospots.findIndex((item) => item._id === hotspotId);
                updatedSpaceNode = produce(node, (draftState) => {
                    draftState.infospots[infospotIndex] = Object.assign(Object.assign({}, draftState.infospots[infospotIndex]), { rotation: {
                            pitch,
                            yaw,
                        } });
                });
            }
            updateSpaceNode({
                spaceId: details._id,
                node: {
                    infospots: updatedSpaceNode.infospots.map((_a) => {
                        var infospot = __rest(_a, ["_id"]);
                        return infospot;
                    }),
                    nodeLinks: updatedSpaceNode.nodeLinks.map((_a) => {
                        var nodeLink = __rest(_a, ["_id", "scale", "autoLink", "visibilityJustification"]);
                        return nodeLink;
                    }),
                },
                nodeId: node._id,
            });
        }
    };
    useEffect(() => {
        const dropContainer = getContainer();
        if (dropContainer) {
            dropContainer.addEventListener("dragover", dropOverCb);
            dropContainer.addEventListener("drop", dropCb);
            return () => {
                dropContainer.removeEventListener("dragover", dropOverCb);
                dropContainer.removeEventListener("drop", dropCb);
            };
        }
    }, [getContainer]);
    return null;
};

export { HotspotDropBox, HotspotDropBox as default };
